import * as React from "react";
import styled from "styled-components";
import BodySmall from "../typography/BodySmall";
import { HorizontalSpacer } from "../Spacers";
import { theme } from "../../../theme";
import Small from "../typography/Small";

const MultilineTextFieldStyle = styled.textarea<{ error?: boolean }>`
  width: 100%;
  border: ${(props) =>
    props.error
      ? `1.25px solid ${theme.colors.error}`
      : `1.25px solid ${theme.colors.grey40}`};
  padding: 4px;
  border-radius: 4px;
  font-family: Inter;
  color: ${() => theme.colors.text};
  background-color: white;
  font-size: 14px;
  min-height: 164px;
  box-sizing: border-box;

  &:focus {
    border: 1.25px solid ${theme.colors.text};
    outline: none;
  }
  &::placeholder {
    color: #a1acbc;
  }
`;

interface Props {
  label?: string;
  value?: string;
  placeholder?: string;
  errorMessage?: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  defaultValue?: string;
  rows?: number;
}

const MultilineTextField: React.FC<Props> = ({
  label,
  value,
  placeholder,
  errorMessage,
  onChange,
  disabled,
  defaultValue,
  rows,
}) => {
  const hasError = !!errorMessage;

  return (
    <div>
      <Small
        color={disabled ? theme.colors.disabled : theme.colors.textSecondary}
      >
        {label}
      </Small>
      <HorizontalSpacer spacing={0.25} />
      {disabled ? (
        <BodySmall>{value ?? defaultValue}</BodySmall>
      ) : (
        <MultilineTextFieldStyle
          defaultValue={defaultValue}
          placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)}
          value={value}
          error={hasError}
          rows={rows}
          inputMode="text"
        />
      )}
      {errorMessage && (
        <BodySmall color={theme.colors.error}>{errorMessage}</BodySmall>
      )}
    </div>
  );
};

export default MultilineTextField;
